import { Pipe, PipeTransform } from '@angular/core';
import { IdTagUserType } from '../enums/id-tag-user-type.enum';
import { translateIdTagUserType } from '../mappers/enum-translation-mapper';

@Pipe({
  name: 'translateIdTagUserTypeEnum',
})
export class TranslateIdTagUserTypeEnum implements PipeTransform {
  transform(value: any): any {
    if (Array.isArray(value)) {
      value.forEach(element => {
        const problemTypeEnum = element as { name: any; index: any };
        problemTypeEnum.name = translateIdTagUserType(problemTypeEnum.index);
      });
      return value;
    } else {
      const enumValue: IdTagUserType = IdTagUserType[value as keyof typeof IdTagUserType];
      return translateIdTagUserType(enumValue);
    }
  }
}
